/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useProductDetails } from '@/features/product/api/getProductDetails';
import { useCallback } from 'react';

export function useBvPixelTracking() {
  const { data: productDetailsData } = useProductDetails({ enabled: false });
  const product = productDetailsData?.product;

  const trackEvent = useCallback(
    (featureType: string, eventType: string, name: string, term?: string | number) => {
      if (typeof BV !== 'undefined' && BV?.pixel) {
        BV.pixel.trackEvent(featureType, {
          type: eventType,
          name: name,
          bvProduct: 'RatingsAndReviews',
          productId: product?.itemId,
          categoryId: product?.categoryId,
          ...(term ? { filterBy: term } : {}),
        });
      }
    },
    [product]
  );

  return { trackEvent };
}
